module.exports = __webpack_public_path__ + "img/s1-0.d834f3ca.svg";